import { useEffect, useState } from 'react';

const getResource = (res, args = {}) => {
  if (res === null) return null;

  const { metaOverride, attributes = {} } = args;

  if (!metaOverride) {
    return res.copy();
  }

  return res.copy()
    .meta()
    .merge(metaOverride)
    .parent()
    .attributes({ ...attributes });
};

export default function useResourceDeprecated(initial = null, args = {}) {
  let initialResource = initial; // Rename initial

  const [initialized, setInitialized] = useState(false);

  // Only run this expensive logic until the hook has initialized
  if (initial !== null && !initialized) {
    initialResource = getResource(initial, args);
  }

  const [resource, setResource] = useState(initialResource);

  useEffect(() => {
    // Run once
    setInitialized(true);
  }, []);

  return {
    resource,
    setResource: (v) => {
      setResource((v === null) ? v : v.copy());
    },
  };
}
